<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="invoicingDetailTable"  v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<goodsspu-box ref="goodsspuBox" @submit="goodsspuSubmit" />
				<editcargo-Form ref="editcargoForm" :goodsUids="goodsUids" :currentrow="detailcurrentrow" @submit="editcargoSubmit" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"订单信息"
					]
				},
				{
					"type": "$input",
					"field": "ordercode",
					"title": "系统单号",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true,
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "invoiceattr",
					"title": "发票类型",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true,
						"name":"invoiceattr",
						"formatter":"invoiceattr"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "amount",
					"title": "订单金额",
					"props": {
						"readonly":true
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "invoicepreamount",
					"title": "预开票金额",
					"props": {
						"readonly":true,
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"税务信息"
					]
				},
				{
					"type": "$inputNumber",
					"field": "invoiceamount",
					"title": "不含税金额",
					"props": {
						"readonly":true,
						"precision":4
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "invoicetax",
					"title": "税额",
					"props": {
						"readonly":true,
						"precision":4
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "invoiceamountwithtax",
					"title": "价税合计",
					"props": {
						"readonly":true,
						"precision":4
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 6,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import goodsspuBox from './box/goodsspu.vue'
	import editcargoForm from '@/components/reports/reconciliationbankflow/lib/goodsspu/editcargo.vue'
	export default {
		mixins: [modalMixins,listMixins],
		props: {
			currentrow: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				detailcurrentrow:{},
				modal_model:false,
				modal_title: '开票',
				modal_width:1200,
				modal_height:800,
				goodsUids:[],
				list_footerField:[
					{field:'num',toFixed:2},
					{field:'amount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 550
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'invoicetypecode',
						title: '品类编码',
						editRender: {
							name: '$input',
							props: {
								readonly:true,
							},
							events: {
								
							}
						},
					}, {
						field: 'goodscode',
						title: '规格编码',
						editRender: {
							name: '$input',
							props: {},
							events: {
								
							}
						},
					},{
						field: 'invoicetype',
						title: '品类类型',
						editRender: {
							name: '$input',
							props: {
								//readonly:true,
							},
							events: {
								
							}
						},
			
					}, {
						field: 'invoicetypename',
						title: '品类名称',
						editRender: {
							name: '$input',
							props: {
								//readonly:true,
							},
							events: {
								
							}
						},
			
					}, {
						field: 'invoicetypeunit',
						title: '单位',
						editRender: {
							name: '$emun',
							props: {
								name:"unit",
								formatter:"unit",
								//readonly:true,
							},
							events: {
								
							}
						},
					}, {
						field: 'invoicetypeclass',
						title: '规格',
						editRender: {
							name: '$input',
							props: {
								//readonly:true,
							},
							events: {
								
							}
						},
					}, {
						field: 'num',
						title: '数量',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:4
							},
							events: {
								change:({row})=>{
									this.numChange(row)
								}
							}
						},
					}, {
						field: 'price',
						title: '单价',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:4
							},
							events: {
								change:({row})=>{
									this.priceChange(row)
								}
							}
						},
					}, {
						field: 'amount',
						title: '金额',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:4
							},
							events: {
								change:({row})=>{
									this.amountChange(row)
								}
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.cargoconfig(row)}}>存货</el-button>,
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					invoicetypeclass: [{
						required: true,
						message: '缺少必填项【规格】',
					}],
					invoicetypename: [{
						required: true,
						message: '缺少必填项【品类名称】',
					}],
					invoicetypeunit: [{
						required: true,
						message: '缺少必填项【单位】',
					}],
					num: [{
						required: true,
						message: '缺少必填项【数量】',
					}],
					price: [{
						required: true,
						message: '缺少必填项【单价】',
					}],
					amount: [{
						required: true,
						message: '缺少必填项【金额】',
					}]
				}
			},
			numChange(row){
				row.price = parseFloat(row.amount) / parseFloat(row.num)
			},
			priceChange(row){
				row.num = parseFloat(row.amount) / parseFloat(row.price)
			},
			amountChange(row){
				row.price = parseFloat(row.amount) / parseFloat(row.num)
			},
			cargoconfig(row){
				this.detailcurrentrow = row
				this.goodsUids = [row.goodsUid]
				this.$nextTick(()=>{
					this.$refs.editcargoForm.modal_show()
				})
			},
			editcargoSubmit(){
				this.getgrid().commitProxy('query')
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoiceoutput.listTrades(null,{
						ordercode:this.currentrow.ordercode,
					}).then((res)=>{
						//console.log(res,1000)
						let data = res.data
						if (data.length == 0) {
							resolve({
								list: []
							})
							this.$message.error('暂无订单信息')
						} else {
							let orders = []
							data[0].relation_data.forEach((item) => {
								orders = orders.concat(item.orders)
							})
							let goods = orders.map((_item)=>{
								return {
									code:_item.bar_code,
									num:_item.size,
									price:_item.price,
									amount:_item.payment,
									specValue:_item.specValue
								}
							})
							this.$api.invoicematch.matchtype({goods:goods}).then((res)=>{
								this.computeaAmount(res)
								resolve({
									list: res
								})
							},()=>{
								resolve({
									list: []
								})
							})
						}
						
					},()=>{
						resolve({
							list: []
						})
					})
					
				
				})
			},
			modal_init(){
				this.sourceData = this.currentrow
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.invoicingDetailTable
			},
			goodsspuSubmit(e){
				console.log(e)
				let data = []
				data = e.data.map((item)=>{
					return {
						id:item.id,
						invoicetype:item.invoicetype,
						invoicetypecode:item.invoicetypecode,
						invoicetypename:item.invoicetypename,
						goodscode:item.goodscode,
						invoicetypeunit:item.unit,
						invoicetypeclass:item.goodsmodel,
						invoicetypeid:null,
						goodsName:item.goodsname,
						cargotypeid:item.cargotypeid,
						goodsUid:item.goodsUid,
						amount:0,
						num:0,
						price:0,
					}
				})
				this.getgrid().insert(data).then(()=>{
					this.computeaAmount()
				})
			},
			add(){
				this.$refs.goodsspuBox.initList()
				this.$refs.goodsspuBox.box.alertBox()
				
				
			},
			delete(row){
				this.getgrid().remove(row)
				this.$nextTick(()=>{
					this.computeaAmount()
				})
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							//console.log(submitData)
							this.submitDataFormater(submitData)
							let detail = this.getgrid().getTableData().visibleData
							let data = {}
							data.main = submitData
							data.main.id = this.currentrow.id
							data.invoice_detail = detail
							//this.createJson(data)
							this.$api.invoicematch.saveinvoiceinfo({data:data}).then(()=>{
								this.$emit('success', {
									data: JSON.stringify(data)
								})
								this.modal_cancel()
							})

							// this.modal_cancel()
							//console.log(data)
						} else {
							for (let i in res) {
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
						}
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			computeaAmount(tabledata){
				let data = tabledata
				if(!data){
					data = this.getgrid().getTableData().tableData
				}
				let invoiceamount = 0
				let invoicetax = 0
				let invoiceamountwithtax = 0
				data.forEach((item)=>{
					invoiceamountwithtax += parseFloat(item.amount)
				})
				if(this.fApi.getValue('invoiceattr') == 331 || this.fApi.getValue('invoiceattr') == 321 ){
					invoicetax = invoiceamountwithtax * 0.13
				}else{
					invoicetax = invoiceamountwithtax * 0.01
				}
				invoiceamount = invoiceamountwithtax - invoicetax
				
				this.fApi.setValue('invoiceamount',invoiceamount)
				this.fApi.setValue('invoicetax',invoicetax)
				this.fApi.setValue('invoiceamountwithtax',invoiceamountwithtax)
			},
			reset() {
				//this.init()
			}
		},
		components: {
			goodsspuBox,
			editcargoForm
		}
	}
</script>